import { render } from "./App.vue?vue&type=template&id=b4d91a58"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=b4d91a58&lang=css"
script.render = render

export default script